import {
  Button, Card, CardContent, CardHeader, CircularProgress,
  Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, ExpansionPanel,
  ExpansionPanelDetails, ExpansionPanelSummary, List, ListItem, ListItemAvatar, ListItemText, Paper, Table, TableBody,
  TableCell, TableContainer, TableRow, Typography
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { GoRadioTower } from 'react-icons/go';
import { connect } from 'react-redux';
import axios from 'src/utils/axios';
import { getTokenWs, getUser, openBlob } from 'src/utils/Common';
import { loadBaslandiJob } from 'src/utils/storage/StartWorkOrder';

const useStyles = makeStyles((theme) => ({
  root: {},
  content: {
    padding: 0
  },
  contentMin: {
    padding: 0,
    minHeight: 390,
  },
  inner: {
    minWidth: 1150
  },
  methodCell: {
    width: 100
  },
  statusCell: {
    width: 64
  },
  baslik: {
    padding: theme.spacing(1)
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  divider: {
    backgroundColor: '#1D3343'
  },

}));

function Yardimci({
  className, ReceiptNo, tasks, readonly, ...rest
}) {
  const classes = useStyles();
  const { t } = useTranslation('work_order');
  const [YardimciData, setYardimciData] = useState([]);
  const [YardimciDataLibrary, setYardimciDataLibrary] = useState([]);
  const [YardimciDataLibraryDetail, setYardimciDataLibraryDetail] = useState([]);
  const [Loading, setLoading] = useState(true);
  const [expanded, setExpanded] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [Uyari, setUyari] = React.useState('');

  const SessionUser = getUser();

  const YardimciDataDeger = readonly ? tasks.tasks.filter((d) => parseInt(d.ReceiptNo) === parseInt(ReceiptNo)) : loadBaslandiJob();
  const KulModelKodu = YardimciDataDeger[0].ModelCode;
  const Uyil = YardimciDataDeger[0].ProductionYear || 0;
  let Udonem = YardimciDataDeger[0].ProductionMonth || 0;
  const SeriNo = YardimciDataDeger[0].SerialNumber || 0;
  let NitelikKodu = YardimciDataDeger[0].AttributeId || 0;
  let { Barcode } = YardimciDataDeger[0];
  useEffect(() => {
    let mounted = true;
    const fetchLogs = () => {

      // axios.get('/GetArtemisLibrary/' + KulModelKodu).then(response => {
      //   if (mounted) {
      //     const DegerLibrary = response.data === "" ? [] : response.data;
      //     setYardimciDataLibrary(DegerLibrary);
      //     setLoading(false);
      //   }
      // }).catch(error => {
      //   setLoading(false);
      // });
    };
    fetchLogs();
    return () => {
      mounted = false;
    };
  }, [KulModelKodu]);

  const GetLibraryDetail = (panel) => {
    setLoading(true);
    axios.get(`/GetArtemisDetailLibrary/${KulModelKodu}/${panel}`).then((response) => {
      const Deger = response.data === '' ? [] : response.data;
      setYardimciDataLibraryDetail(Deger);
      setLoading(false);
    }).catch((error) => {
      setLoading(false);
    });
  };

  const DetayAc = (log) => {
    setLoading(true);
    const data = {
      ServiceShopId: SessionUser.ServiceShopId,
      UserId: SessionUser.UserId,
      FilePtr: log.FP,
    };
    const config = {
      responseType: 'blob',
      headers: { 'Content-Type': 'application/json' }
    };
    axios.post('/FileImportExport/SiriusBulletin', data, config)
      .then((response) => {
        openBlob(response.data, `${log.BK}_${log.BN}`);
        setLoading(false);
      }).catch((error) => {
        setUyari(t('Bulten_acilamadi'));
        setOpen(true);
        setLoading(false);
      });
  };

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
    if (isExpanded === true) {
      GetLibraryDetail(panel);
    }
  };

  const handleOpenTHelper = (event, Link) => {
    event.persist();
    window.open(Link);
    event.persist();
  };


  const IOTKartEslemeAc = (event) => {
    if (Barcode === '0' || Barcode === '' || Barcode === undefined) {
      if (KulModelKodu === undefined || KulModelKodu === '0' || KulModelKodu === '') {
        setUyari(t('IOT_error'));
        setOpen(true);
        return;
      }
      if (Udonem === undefined || Udonem === '0' || Udonem === '') {
        setUyari(t('IOT_error'));
        setOpen(true);
        return;
      }
      if (Uyil === undefined || Uyil === '0' || Uyil === '') {
        setUyari(t('IOT_error'));
        setOpen(true);
        return;
      }
      if (SeriNo === undefined || SeriNo === '0' || SeriNo === '') {
        setUyari(t('IOT_error'));
        setOpen(true);
        return;
      }

      if (Udonem.toString().length === 1) {
        Udonem = `0${Udonem}`;
      }
      if (NitelikKodu === '0') {
        NitelikKodu = '02';
      } else {
        NitelikKodu = '01';
      }
      Barcode = KulModelKodu + Uyil.toString().substring(2, 4) + SeriNo.toString() + Udonem.toString() + NitelikKodu.toString();
    }

    if (Barcode === '0' || Barcode === '' || Barcode === undefined) {
      setUyari(t('Barcode_error'));
      setOpen(true);
      return;
    }

    event.persist();
    const SessionTokenWs = getTokenWs();
    let Link = process.env.REACT_APP_IOT_URL;
    Link = `${Link}?SessionToken=${SessionTokenWs}&Barcode=${Barcode}`;
    window.open(Link);
    event.persist();
  };

  const user = getUser();
  const user_types = user.TechnicianType.split(',');
  let klima_teknisyeni = false;
  user_types && user_types.forEach((u) => {
    if (parseInt(u.TIP) === 26) {
      klima_teknisyeni = true;
    }
  });
  if (klima_teknisyeni) {
    return (
      <Card>
        <CardHeader title={t('Yetki_Kontrolu')} />
        <Divider />
        <CardContent className={classes.contentMin}>
          {t('Yetki_Kontrolu_Mesaji')}
        </CardContent>
      </Card>
    );
  }

  const handleClose = () => {
    setOpen(false);
  };


  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">{t('Bilgilendirme')}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {Uyari}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            {t('Tamam')}
          </Button>
        </DialogActions>
      </Dialog>
      {window.navigator.onLine
        ? (
          <div className={clsx(classes.root, className)}>
            <Card className={classes.contentMin}>
              <CardHeader title={t('IOT_islemler')} />
              <Divider />
              <CardContent className={classes.content}>
                <List className={classes.root}>
                  <ListItem
                    alignItems="flex-start"
                    onClick={(event) => IOTKartEslemeAc(event)}
                  >
                    <ListItemAvatar>
                      <GoRadioTower style={{ color: '#1D3343' }} />
                    </ListItemAvatar>
                    <ListItemText primary={t('IOT_text')} />
                  </ListItem>
                </List>
                <Divider />
              </CardContent>
            </Card>
            {/* <Divider className={classes.divider} /> */}
            {/* <Card className={classes.contentMin}>
            <CardHeader title={t('Kutuphane')} />
            {YardimciDataLibrary.map(log => (
              <ExpansionPanel key={log.ACIKLAMA} expanded={expanded === log.BANKATIPI} onChange={handleChange(log.BANKATIPI)}>
                <ExpansionPanelSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                >
                  <Typography className={classes.heading}>{log.ADET} Adet</Typography>
                  <Typography className={classes.secondaryHeading}>{log.ACIKLAMA}</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                  <TableContainer component={Paper}>
                    <Table className={classes.table} aria-label="simple table">
                      <TableBody>
                        {YardimciDataLibraryDetail.map(row => (
                          <TableRow
                            key={row.A}
                          >
                            <TableCell component="th"
                              onClick={(e) => DetayAc(row)}
                              scope="row">
                              {row.A}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </ExpansionPanelDetails>
              </ExpansionPanel>
            )
            )}
          </Card> */}
          </div>
        )
        : (
          <Card className={clsx(classes.root, className)}>
            <CardHeader title={t('Teknisyen_Yardimcisi')} />
            <CardContent className={classes.contentMin}>
              {t('Offline_Message')}
            </CardContent>
          </Card>
        )}
    </div>
  );
}

Yardimci.propTypes = {
  className: PropTypes.string
};

export default connect(
  (state) => ({ tasks: state.tasks1 })
)(Yardimci);
